import config from "../../config";
const baseUrl = config.baseUrl;

export const  PrivacyPolicyUrls =  {
  PRIVACYPOLICY_LIST: baseUrl + "/privacy_policy",
  PRIVACYPOLICY_ADD: baseUrl + "/privacy_policy",
}